import Dexie from "dexie";
import db from "../Db";

var UpdateInterven = Dexie.async(function* (INTERVEN) {
  yield db.open();
  yield db.INTERVEN.put(INTERVEN);
});

export default UpdateInterven;
